export default function uniqid(prefix) {
  return `${prefix}${crypto.randomUUID().replaceAll("-", "").slice(0, 13)}`;
}
